"use strict";
/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadBidder__factory = void 0;

var ethers_1 = require("ethers");

var BadBidder__factory = /*#__PURE__*/function (_ethers_1$ContractFac) {
  _inherits(BadBidder__factory, _ethers_1$ContractFac);

  var _super = _createSuper(BadBidder__factory);

  function BadBidder__factory(signer) {
    _classCallCheck(this, BadBidder__factory);

    return _super.call(this, _abi, _bytecode, signer);
  }

  _createClass(BadBidder__factory, [{
    key: "deploy",
    value: function deploy(_auction, _zora, overrides) {
      return _get(_getPrototypeOf(BadBidder__factory.prototype), "deploy", this).call(this, _auction, _zora, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(_auction, _zora, overrides) {
      return _get(_getPrototypeOf(BadBidder__factory.prototype), "getDeployTransaction", this).call(this, _auction, _zora, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(BadBidder__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(BadBidder__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
  }]);

  return BadBidder__factory;
}(ethers_1.ContractFactory);

exports.BadBidder__factory = BadBidder__factory;
var _abi = [{
  inputs: [{
    internalType: "address",
    name: "_auction",
    type: "address"
  }, {
    internalType: "address",
    name: "_zora",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  stateMutability: "payable",
  type: "fallback"
}, {
  inputs: [{
    internalType: "uint256",
    name: "auctionId",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "amount",
    type: "uint256"
  }],
  name: "placeBid",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}, {
  stateMutability: "payable",
  type: "receive"
}];
var _bytecode = "0x608060405234801561001057600080fd5b506040516102093803806102098339818101604052604081101561003357600080fd5b810190808051906020019092919080519060200190929190505050816000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555080600160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505050610129806100e06000396000f3fe608060405260043610601f5760003560e01c806357c90de5146027576025565b36602557005b005b605a60048036036040811015603b57600080fd5b810190808035906020019092919080359060200190929190505050605c565b005b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663b7751c718284846040518463ffffffff1660e01b815260040180838152602001828152602001925050506000604051808303818588803b15801560d757600080fd5b505af115801560ea573d6000803e3d6000fd5b5050505050505056fea26469706673582212206d0a7dd53ec14011741e986c03042e3ae9015cb888da88f9872d356aa1e70a8364736f6c63430006080033";